<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 18 21">
    <g clip-path="url(#clip0_6892_9155)">
      <path
        d="M6.12984 18.5437V10.2173H4.98407V18.5437L0.80202 14.2267L-0.0114746 15.0665L5.5455 20.8027L11.1025 15.0665L10.289 14.2267L6.10692 18.5437H6.12984ZM5.5455 19.1233H5.56841H5.55695H5.5455ZM17.1865 7.37872L13.0044 3.06175V11.4592H11.8587V3.06175L7.67662 7.37872L6.86313 6.53898L12.4316 0.802734L17.9885 6.53898L17.175 7.37872H17.1865Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_9155">
        <rect width="18" height="20" fill="white" transform="translate(0 0.802734)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
